import type { Nullable } from 'corgi-types';

import type { PromoEvent } from '../enums/Tracking';

export interface DyTrackingParams {
  dyDecisionId?: string;
  dyVariationId?: number;
  visitorHash?: string;
}

export interface CampaignTrackingData extends DyTrackingParams {
  name: Nullable<string>;
  placement?: string;
  position?: number;
  label?: string;
  interaction?: string;
  constructorAdId?: string;
}

export interface PromoClickTrackingData {
  interaction?: string;
  element?: string;
}

interface CampaignEventDataParams extends CampaignTrackingData, PromoClickTrackingData {
  promoEvent: PromoEvent;
  type?: string;
}

export const getPromotionEventData = ({
  promoEvent,
  placement,
  name,
  position = 0,
  visitorHash,
  dyDecisionId,
  dyVariationId,
  constructorAdId,
  label,
  interaction,
  type,
  element,
}: CampaignEventDataParams) => {
  return {
    event: promoEvent,
    creative_name: placement,
    creative_slot: position,
    ...(name && { promotion_name: name }),
    ...(dyDecisionId && { dy_decision_id: dyDecisionId }),
    ...(dyVariationId && { dy_variation_id: dyVariationId }),
    ...(visitorHash && { visitor_hash: visitorHash }),
    ...(constructorAdId && { constructor_ad_id: constructorAdId }),
    ...(label && { label }),
    ...(interaction && { interaction }),
    ...(type && { type }),
    ...(element && { element }),
  };
};
